export var FILE = '__NATIVE_FILE__';
export var URL = '__NATIVE_URL__';
export var TEXT = '__NATIVE_TEXT__';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-html5-backend/dist/esm/NativeTypes.js
// module id = 442
// module chunks = 71